/**
 * @class
 * @description Object that stores the plugin settings.
 * @exports Options
 */
export default class Options {
    /**
     * Constructs options object.
     * @param {constructionOptions} options JSON with the options to construct the balancer.
     */
    constructor(options) {
        // Origin code
        this.originCode = "default";
        // Manifest url of the content being played
        this.resource = '';
        // Optional override manifest
        this.overrideManifest = false;
        // Optional update every x seconds
        this.updateTime = 0;
        // Optional report every x seconds
        this.reportTime = 0;
        // Optional report every x seconds
        this.debug = false;
        this.accountCode = options.accountCode;
        this.token = options.token;
        if (options.originCode)
            this.originCode = options.originCode;
        this.applicationCode = options.applicationCode;
        this.isLive = options.isLive || false;
        this.videoId = options.videoId;
        if (options.overrideManifest)
            this.overrideManifest = options.overrideManifest;
        if (options.updateTime) {
            this.updateTime = options.updateTime;
        }
        if (options.reportTime) {
            this.reportTime = options.reportTime;
        }
        if (options.debug) {
            this.debug = options.debug;
        }
    }
}
